import { mapActions, mapMutations } from "vuex";

export const knowledgePointReviewMixins = {
  data() {
    return {
      formData: {
        contents: [
          {
            content: "",
          },
        ],
      },
      form: {
        contents: [
          {
            content: "",
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions("courseCenter", ["savePointReviewContent"]),
    ...mapMutations("courseCenter", ["setData"]),
    //表单清空
    clearForm() {
      this.formData = {
        contents: [
          {
            content: "",
          },
        ],
      };
    },
    async handleFinished() {
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.form.contents = this.formData.contents.filter(
            (item) => item.content.trim().length !== 0
          );
          await this.savePointReviewContent({
            lessonId: this.lessonId,
            version: this.version,
            ...this.form,
          });
          this.$message.success("提交成功");
          await this.setData({
            key: "knowledgePointReviewModalVisible",
            value: false,
          });
        }
      });
    },
  },
};
